import React  from 'react';

import sheding1 from '../assets/img/sheding1.png';
import sheding2 from '../assets/img/sheding2.png';

const Enclosure22 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div>
            <img src={sheding1} alt="" style={{
                width  : '100%',
                display: 'block',
                margin : '0 auto'
            }}/>

            <br/><br/>
        </div>
    </div>



export default Enclosure22;